import { render, staticRenderFns } from "./RequireCreatePassword.vue?vue&type=template&id=bcb0d5ac&"
import script from "./RequireCreatePassword.vue?vue&type=script&lang=ts&"
export * from "./RequireCreatePassword.vue?vue&type=script&lang=ts&"
import style0 from "./RequireCreatePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports